import React from "react"
import { RadioButtonsFieldProps, RadioButtonsField } from "./RadioButtonsField"

export type BooleanFieldProps = Omit<RadioButtonsFieldProps, 'lookup' | 'onChange'> & {
  yesText: string
  noText: string
  noFirst?: boolean
  value: boolean | null | undefined
  onValueChange: (value: boolean | null) => void
}

export const BooleanField = (props: BooleanFieldProps) => {
  const { yesText, noText, noFirst, value, onValueChange, ...rest } = props
  const _lookup = noFirst
    ? [{ code: "0", name: noText }, { code: "1", name: yesText },]
    : [{ code: "1", name: yesText }, { code: "0", name: noText },]
  return (
    <RadioButtonsField
      lookup={_lookup}
      value={value === true ? "1" : value === false ? "0" : null}
      onChange={(e, value) => onValueChange(value === '1' ? true : value === '0' ? false : null)}
      {...rest}
    />
  )
}